import React, { useState, useEffect } from 'react';
import Sidemenu from '../base/sidemenu';
import { useLocation, useNavigate } from 'react-router-dom';

export default function DeviceEdit() {
  const location = useLocation();
  const navigate = useNavigate();
  const device = location.state?.device || {};
  const handleGoBack = () => {
    navigate(-1);
  };
  const handleUpdate = () => {
    // 여기에 수정 API 호출 코드 작성
    console.log({
      id, name, place
    });
    alert("수정되었습니다.");
    navigate(-1);
  };

  const [id, setId] = useState(device.id);
  const [name, setName] = useState(device.name);
  const [place, setPlace] = useState(device.place);

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="device">
        <h1>장비 관리</h1>
        <div className='device_box'>
          <h2 className="subpage_title"><span className="before"><span className="nametit">{device.id}</span> 수정</span></h2>      
          <div className='device_edit'>
            <div className='table02'>
              <table>
                <caption>장비 수정 표</caption>
                <colgroup>
                  <col width="20%" />
                  <col width="80%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope='row'>장비ID</th>
                    <td><input type="text" value={id} onChange={e => setId(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>장비이름</th>
                    <td><input type="text" value={name} onChange={e => setName(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>장비설치위치</th>
                    <td><input type="text" value={place} onChange={e => setPlace(e.target.value)} /></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="btn-group">
              <button className="btncolor02" onClick={handleGoBack}>뒤로</button>
              <button className="btncolor01" onClick={handleUpdate}>수정완료</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
